export default function TrustSignals() {
  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-[#FFF8F0] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            We Connect You at No Cost
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-700 max-w-3xl mx-auto mb-6">
            Our service is <strong>100% free</strong> for accident victims. We only succeed when you get the compensation you deserve.
          </p>
          <div className="flex justify-center">
            <a 
              href="#contact" 
              className="inline-block bg-[#D2691E] text-white px-8 py-3 sm:px-10 sm:py-4 md:px-16 md:py-5 rounded-full text-base sm:text-lg md:text-2xl font-extrabold hover:bg-[#A0522D] transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
            >
              Value Your Claim
            </a>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mt-8 md:mt-16">
          <div className="text-center p-6 md:p-8 bg-white rounded-xl shadow-lg">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#2D5016] rounded-full mb-4 md:mb-6 mx-auto">
              <i className="ri-shield-check-line text-2xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
              Trusted Network
            </h3>
            <p className="text-sm md:text-base text-gray-700">
              We only work with vetted, experienced attorneys and medical providers in the Las Cruces area
            </p>
          </div>

          <div className="text-center p-6 md:p-8 bg-white rounded-xl shadow-lg">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#2D5016] rounded-full mb-4 md:mb-6 mx-auto">
              <i className="ri-time-line text-2xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
              Fast Response
            </h3>
            <p className="text-sm md:text-base text-gray-700">
              Get connected with the right professionals within 24 hours of submitting your case
            </p>
          </div>

          <div className="text-center p-6 md:p-8 bg-white rounded-xl shadow-lg sm:col-span-2 lg:col-span-1">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#2D5016] rounded-full mb-4 md:mb-6 mx-auto">
              <i className="ri-map-pin-line text-2xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
              Local Expertise
            </h3>
            <p className="text-sm md:text-base text-gray-700">
              Our partners know New Mexico law and the Las Cruces court system inside and out
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}